jQuery(document).ready(function ($) {
  $(".card-block p:has(a)").each(function () {
    if ($(this)[0]?.childNodes[$(this)[0]?.childNodes?.length - 1]?.tagName == "A") {
      $(this).addClass("has-link")
    }
  })

  $(".card-block.has-url").on("click", function (e) {
    if (!$(e.target).is("a")) {
      if ($(this).data("target") == "_blank") {
        window.open($(this).data("url"))
      } else {
        window.location.href = $(this).data("url")
      }
    }
  })
})
